const getFitAction = (paperLayout, photoLayout, stretchImage) => {
  const bothLandscape =
    paperLayout === 'landscape' && photoLayout === 'landscape';
  const bothPortrait = paperLayout === 'portrait' && photoLayout === 'portrait';
  const paperLandPhotoPortrait =
    paperLayout === 'landscape' && photoLayout === 'portrait';
  const paperPortraitPhotoLand =
    paperLayout === 'portrait' && photoLayout === 'landscape';
  if (stretchImage) {
    if (bothLandscape || paperPortraitPhotoLand) {
      return 'fitHeight';
    }
    if (bothPortrait || paperLandPhotoPortrait) {
      return 'fitWidth';
    }
  } else {
    if (bothPortrait || paperLandPhotoPortrait) {
      return 'fitHeight';
    }
    if (bothLandscape || paperPortraitPhotoLand) {
      return 'fitWidth';
    }
  }
};

export default getFitAction;
